import { Box } from "@mui/material";
import treasureLogo from "../assets/treasure-logo.png";

const BrandMark = ({ size = 36, alt = "" }) => (
  <Box
    component="img"
    src={treasureLogo}
    alt={alt}
    width={size}
    height={size}
    sx={{
      width: size,
      height: size,
      borderRadius: `${Math.round(size * 0.22)}px`,
      display: "block",
      flexShrink: 0,
      objectFit: "cover",
    }}
  />
);

export default BrandMark;
